import {
  generateMockParseCSVResponse,
  generateMockProducts,
  generateMockMetaFields
} from './generators';

export const getMockData = () => ({
  parseCSVResponse: generateMockParseCSVResponse(),
  products: generateMockProducts(20),
  metaFields: generateMockMetaFields()
});